import { getCookie } from '../../utils/utils';
const FAKE_BSI_GUID = 'ca5caded-dead-feed-c0d5-ba11ad5c1a55';
const callSafe = function (Wix, fn) {
  if (Wix && Wix.Utils && typeof Wix.Utils[fn] === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return Wix.Utils[fn](...args);
  }
};
const getBsiParams = () => {
  const bsiCookie = getCookie('bSession');
  if (!bsiCookie) {
    return {};
  }
  const [bsi, bsi_page_number] = bsiCookie.split('|');
  return {
    browsing_session: bsi,
    bsiPageNumber: bsi_page_number,
    bsi: bsiCookie
  };
};
const getBsi = () => getBsiParams().bsi || FAKE_BSI_GUID;
const getVisitorId = () => callSafe(window.Wix, 'getInstanceValue', 'aid') || getCookie('_wixCIDX');
export const getUoUParams = () => ({
  bsi: getBsi(),
  visitor_id: getVisitorId()
});